import StoreManager from "../appdata";

// Hàm sampleString
// function sampleString(inputData, numberOfSample = 4096, sampleLength = 1) {
//     if (inputData.length <= numberOfSample) {
//         return inputData;
//     }

//     let inputDataNew = trimStringToMultiple(numberOfSample, inputData);
//     let bs = Math.floor(inputDataNew.length / numberOfSample);
//     let temporaryStringBuilder = [];

//     measureExecutionTime("Execution time", () => {
//         for (let i = 0; i < numberOfSample; i++) {
//             let f = i * bs;
//             let t = f + 1;
//             temporaryStringBuilder.push(inputDataNew.substring(f, t));
//         }
//     });

//     let dataString = temporaryStringBuilder.join("");

   

//     return dataString;
// }

function sampleString(inputData, numberOfSample = 4096, sampleLength = 1) {
    let ret = inputData; // Trả về nguyên chuỗi nếu chiều dài <= numberOfSample * sampleLength
    let temporaryStringBuilder = [];
    let inputLength = inputData.length;

    if (inputLength > numberOfSample * sampleLength) {
        let lengthOfSubData = Math.floor(inputLength / numberOfSample); // Chia lấy phần nguyên
        
        if (sampleLength > lengthOfSubData) {
            sampleLength = lengthOfSubData;
        }

        for (let i = 0; i < numberOfSample; i++) {
            let beginSamplePosition = lengthOfSubData * i;
            let endSamplePosition = beginSamplePosition + sampleLength;
            let sampleData = inputData.substring(beginSamplePosition, endSamplePosition);
            temporaryStringBuilder.push(sampleData);
        }

        ret = temporaryStringBuilder.join(""); // Ghép các sample lại thành chuỗi
    }

    return ret;
}



// Hàm trimStringToMultiple
function trimStringToMultiple(numberOfSample, input) {
    let length = input.length;
    let remainder = length % numberOfSample;

    return remainder === 0 ? input : input.slice(0, -remainder);
}

// Hàm đo thời gian thực thi
function measureExecutionTime(message, block) {
    let startTime = performance.now();
    block();
    let endTime = performance.now();
    // console.log(`${message}: ${(endTime - startTime) / 1000} seconds`);
}
// function bigIntToBytes(bigInt) {
//     let hex = bigInt.toString(16).padStart(16, "0");
//     let bytes = new Uint8Array(8);
//     for (let i = 0; i < 8; i++) {
//         bytes[i] = parseInt(hex.substring(i * 2, i * 2 + 2), 16);
//     }
//     return bytes;
// }

function numberToBytes(number, byteLength) {
    let buffer = new ArrayBuffer(byteLength);
    let dataView = new DataView(buffer);

    if (typeof number === 'bigint') {
        if (byteLength === 8) {
            dataView.setBigUint64(0, number, true); // Sử dụng little-endian
        } else {
            throw new Error("For BigInt, byteLength must be 8 (64-bit)");
        }
    } else {
        switch(byteLength) {
            case 1:
                dataView.setUint8(0, number);
                break;
            case 2:
                dataView.setUint16(0, number, true);
                break;
            case 4:
                dataView.setUint32(0, number, true);
                break;
            case 8:
                dataView.setBigUint64(0, BigInt(number), true);
                break;
            default:
                throw new Error("Unsupported byte length");
        }
    }

    return new Uint8Array(buffer);
}

// // Ví dụ sử dụng với số lớn
// let bigNumber = 1738816185000000000n; // Sử dụng 'n' để định nghĩa BigInt
// let byteLength = 8; // 8 bytes for a 64-bit integer
// let bytes = numberToBytes(bigNumber, byteLength);

// console.log(bytes); // Output: Uint8Array [ 0, 24, 81, 235, 204, 174, 0, 0 ]

function stringToBytes(str) {
    return new TextEncoder().encode(str); // Trả về Uint8Array
}
function bytesToNumber(byteArray) {
    let buffer = byteArray.buffer;
    let dataView = new DataView(buffer);

    return dataView.getBigUint64(0, true); // Sử dụng cùng thứ tự little-endian
}

let timestamp = BigInt(Date.now()) * BigInt(1_000_000);
console.log("timestamp (nanoseconds):", timestamp);

let bBytes = numberToBytes(timestamp, 8);
let tmp = bytesToNumber(bBytes);

console.log("tmp (nanoseconds):", tmp);
console.log("Giá trị khớp:", timestamp === tmp); // Phải in ra true
// Hàm getNonce
function getNonce(accessToken) {
    // 1. Tạo 4 byte ngẫu nhiên (tương đương với SecRandomCopyBytes)
    let aBytes = new Uint8Array(4);
    crypto.getRandomValues(aBytes);

    // 2. Lấy timestamp hiện tại (nano giây) và chuyển thành 8 byte
    let timestamp = BigInt(Date.now()) * BigInt(1_000_000);
    console.log("timestamp (nanoseconds):", timestamp);

    let bBytes = numberToBytes(timestamp, 8);

    let tmp = bytesToNumber(bBytes)
    console.log("tmp (nanoseconds):", tmp);

    // 3. Lấy 52 byte đầu từ accessToken
    if (accessToken.length < 52) {
        console.log("Access token is too short");
        return "";
    }

    // let accessTokenFragment = accessToken.substring(0, 52);
    let accessTokenBytes = stringToBytes(accessToken);

    let cBytes = accessTokenBytes.slice(0, Math.min(52, accessTokenBytes.length));

    console.log("First 4 Bytes:", aBytes);
    console.log("Next 8 Bytes Timestamp:", bBytes);
    console.log("Access Token Fragment bytes:", cBytes);

    // 4. Kết hợp tất cả các byte lại thành một mảng
    let nonceBytes = new Uint8Array([...aBytes, ...bBytes, ...cBytes]);

    // 5. Mã hóa thành chuỗi base64
    let nonceBase64 = btoa(String.fromCharCode(...nonceBytes));

    return nonceBase64;
}





// Hàm generateHMAC
// function generateHMAC(nonce, face1_32, face2_32, apiVersion = "1") {
//     let key = StoreManager.appdata.configEkyc.sdkKey;
//     let sdkKeyData = CryptoJS.enc.Base64.parse(key);

//     // Kiểm tra độ dài của Data và lấy 32 byte đầu tiên nếu có đủ
//     if (sdkKeyData.sigBytes >= 32) {
//         sdkKeyData = CryptoJS.lib.WordArray.create(sdkKeyData.words.slice(0, 8), 32);
//     } else {
//         console.log("Chuỗi giải mã ngắn hơn 32 byte.");
//         return "";
//     }

//     let signature = apiVersion + nonce + face1_32 + face2_32;
//     console.log("message", signature);

//     let signatureData = CryptoJS.enc.Utf8.parse(signature);

//     let hmac = CryptoJS.HmacSHA256(signatureData, sdkKeyData);
//     return CryptoJS.enc.Base64.stringify(hmac);
// }
// pyb6CxghgwfhM8wAZXlKMGVYQWlPaUpLVjFRaUxDSmhiR2NpT2lKSVV6STFOaUo5LmV3b2lZMnhwWlc1MFgybA==

async function generateHMAC(nonce, face1_32, face2_32, apiVersion = "1") {
    let keyBase64 = StoreManager.appdata.configEkyc.sdkKey;

    // Giải mã Base64 thành 32 byte key
    let keyBytes = Uint8Array.from(atob(keyBase64), c => c.charCodeAt(0));

    if (keyBytes.length < 32) {
        console.error("Chuỗi giải mã ngắn hơn 32 byte.");
        return "";
    }

    // Giữ đúng 32 byte đầu tiên
    let hmacKey = keyBytes.slice(0, 32);

    // Bước 1: Ghép chuỗi theo format "<apiVersion><nonce><face1_32><face2_32>"
    let signatureString = apiVersion + nonce + face1_32 + face2_32;
    console.log("hmacKey:", hmacKey);
    console.log("hmacKey length:", hmacKey.length);

    console.log("nonce:", nonce);
    console.log("face1_32:", face1_32);
    console.log("face2_32:", face2_32);


    // Bước 2: Encode chuỗi thành UTF-8 bytes
    let signatureBytes = new TextEncoder().encode(signatureString);

    
    // Bước 3: Tính HMAC-SHA256
    let cryptoKey = await crypto.subtle.importKey(
        "raw",
        hmacKey,
        { name: "HMAC", hash: { name: "SHA-256" } },
        false,
        ["sign"]
    );

    console.log("cryptoKey", cryptoKey)
    let hmac = await crypto.subtle.sign("HMAC", cryptoKey, signatureBytes);
    console.log("hmac", hmac)

    // Bước 4: Encode thành Base64
    let signatureBase64 = btoa(String.fromCharCode(...new Uint8Array(hmac)));
    console.log("signatureBase64", signatureBase64)
    return signatureBase64;
}


export { sampleString, trimStringToMultiple, measureExecutionTime, getNonce, generateHMAC };
